import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Card component for consistent card layouts
 */
const Card = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={cn(
            'card',
            className
        )}
        {...props}
    >
        {children}
    </div>
));

Card.displayName = 'Card';

/**
 * CardHeader component
 */
const CardHeader = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={cn(
            'card-header',
            className
        )}
        {...props}
    >
        {children}
    </div>
));

CardHeader.displayName = 'CardHeader';

/**
 * CardTitle component
 */
const CardTitle = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <h3
        ref={ref}
        className={cn(
            'card-title',
            className
        )}
        {...props}
    >
        {children}
    </h3>
));

CardTitle.displayName = 'CardTitle';

/**
 * CardContent component
 */
const CardContent = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={cn(
            'p-6',
            className
        )}
        {...props}
    >
        {children}
    </div>
));

CardContent.displayName = 'CardContent';

/**
 * CardFooter component
 */
const CardFooter = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={cn(
            'flex items-center p-6 pt-0',
            className
        )}
        {...props}
    >
        {children}
    </div>
));

CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardTitle, CardContent, CardFooter };